module.exports = __webpack_public_path__ + "static/cosmos.7a36ae5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/examples/thumbnails/cosmos.png
// module id = 843
// module chunks = 73261030922168